export const SIDEBAR_WIDTH_EXPANDED_PX = 280;
export const SIDEBAR_WIDTH_COLLAPSED_PX = 72;
